import IndividualAssignment from "./IndividualAssignment";

export default IndividualAssignment;
